exports = module.exports = require("../node_modules/.0.28.5@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.github-icon {\n  position: fixed;\n  bottom: -60px;\n  right: -60px;\n  width: 120px;\n  height: 120px;\n  z-index: 9999;\n  background-color: #41B883;\n  transform: rotateZ(-45deg);\n  background-image: url(http://owgk3x2u9.bkt.clouddn.com/github%20%281%29.svg);\n  background-size: 30%;\n  cursor: pointer;\n  background-repeat: no-repeat;\n  background-position: 50% 8%;\n}\n@media (max-width: 750px) {\n.github-icon {\n    display: none;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.0.28.5@css-loader!./node_modules/.13.0.4@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6677980b","scoped":false,"hasInlineConfig":false}!./node_modules/.4.0.5@less-loader/dist/cjs.js?{"globalVars":{"museUiTheme":"'/Users/jiayihu/jiayi/projects/v-verify/node_modules/muse-ui/src/styles/themes/variables/green.less'"}}!./node_modules/.13.0.4@vue-loader/lib/selector.js?type=styles&index=0!./example/App.vue
// module id = 33
// module chunks = 5